module.exports = __webpack_public_path__ + "static/fonts/SourceHanSansSC-VF.ce4979f.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/SourceHanSansSC-VF.otf
// module id = HKps
// module chunks = 1